import HeaderBar from "../../common/HeaderBar";
import SideBar from "../../common/SideBar";
import CreateQuiz from "../teacher/teacher_CreateQuiz/createQuiz";
import TestBody from "./TestBody";

const TestPage = () => {
  return (
    <main className="ff2 main-page main-page--code">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--code">
        <SideBar />
        <TestBody />
      </div>
    </main>
  );
};

export default TestPage;
